import React from "react";
import SbuxRadioGroup from "../../../../../../components/SbuxRadioGroup";
import { Box, FormControlLabel, Radio } from "@mui/material";
import SbuxTranslate from "../../../../../../components/SbuxTranslate";

interface RowData {
  status?: string;
  [key: string]: unknown;
}

interface Props {
  row: RowData;
  mode: string;
  handleModeValueChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const TemporaryMsgMode = ({ row, mode, handleModeValueChange }: Props) => {
  // Draft mode radio is locked only for statuses where draft is semantically invalid.
  // Intentional UX change from previous behaviour: the old code disabled the Draft radio
  // whenever mode === "durationMode", meaning once a user set a schedule they could never
  // switch back to draft. The new predicate allows Draft-status records to freely toggle
  // between draftMode and durationMode (switching back clears the schedule). It only
  // locks the radio when the record is already live, scheduled, disabled, or expired.
  const isDraftModeDisabled =
    row?.status === "Expired" ||
    row?.status === "Disabled" ||
    row?.status === "Active" ||
    row?.status === "Scheduled";

  return (
    <SbuxRadioGroup
      value={mode}
      handleRadioButtonChange={handleModeValueChange ?? (() => {})}
    >
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flex: 1 }}>
          <FormControlLabel
            disabled={isDraftModeDisabled}
            value={"draftMode"}
            control={<Radio size="small" sx={{ padding: "4px" }} />}
            label={
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flex: 1,
                    pointerEvents: mode !== "draftMode" ? "none" : undefined,
                    opacity: mode !== "draftMode" ? 0.6 : undefined,
                  }}
                />
                <Box
                  sx={{
                    fontSize: 13,
                    marginTop: 0.5,
                    flex: 1,
                    marginRight: 1,
                    minWidth: 100,
                  }}
                >
                  <SbuxTranslate>{"Draft mode"}</SbuxTranslate>
                </Box>
              </Box>
            }
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          <FormControlLabel
            value={"durationMode"}
            control={<Radio size="small" sx={{ padding: "4px" }} />}
            label={
              <Box
                sx={{
                  display: "flex",
                  fontSize: 13,
                  flex: 1,
                  pointerEvents: mode !== "durationMode" ? "none" : undefined,
                  opacity: mode !== "durationMode" ? 0.6 : undefined,
                }}
              >
                <Box
                  sx={{
                    fontSize: 13,
                    marginTop: 0.5,
                    flex: 1,
                    marginRight: 1,
                    minWidth: 100,
                  }}
                >
                  <SbuxTranslate>{"Set Duration"}</SbuxTranslate>
                </Box>
              </Box>
            }
          />
        </Box>
      </Box>
    </SbuxRadioGroup>
  );
};

export default TemporaryMsgMode;
